// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/DespesasStatus_CarregaStatusInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for POST /config/despesas_status/carrega_status
 *
 * Fetches all expense statuses. No body required.
 */
import { registerContract } from './validate'

export interface DespesasStatus_CarregaStatusInput {}

registerContract('DespesasStatus_CarregaStatusInput', {})
